import { Apollo } from 'apollo-angular';
import { Injectable, afterRender, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public isLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isLoggedIn$ = this.isLoggedInSubject.asObservable().pipe(distinctUntilChanged());
  public get isLoggedIn() { return this.isLoggedInSubject.value; }

  constructor(
    private router: Router, 
    private apollo: Apollo,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    afterRender(() => {
      if (isPlatformBrowser(this.platformId) && localStorage.getItem('token')) {
        this.isLoggedInSubject.next(true);
      }
    });
  }

  public logout() {
    this.apollo.client.resetStore().then(() => {
      this.isLoggedInSubject.next(false);
      this.router.navigate(['/']);
      if (isPlatformBrowser(this.platformId)) {
        localStorage.clear();
      }
    });
  }
}
